import { FontWeight, ITheme, mediaQuery } from '@quicktools/shared-components/styles';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    inputClassName: {
      resize: 'none',
    },
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    error: {
      marginTop: 0,
    },
    labelContainer: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
    },
    wordLabel: {
      marginLeft: 'auto',
      marginTop: 'auto',
      color: 'var(--x-text-color-6)',
      fontSize: 12,
      lineHeight: '16px',
      fontWeight: FontWeight.SemiBold,
    },
    noMargin: {
      marginTop: 0,
      marginLeft: 0,
    },
    left: {
      alignItems: 'center',
      display: 'flex',
      gap: 8,
      [mediaQuery(breakpoints.tablet)]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },
  }),
  { name: 'generic-input-area' },
);
export default useStyles;
